import { ReactComponent as LogoSVG } from '../../assets/logo.svg'
import styles from './mobileStyles.module.css'

export default function MobileMenu() {
  const buttonStyles = [
    { background: 'linear-gradient(90deg, #EA3326 0%, #81171E 100%)' },
    { background: 'linear-gradient(90deg, #81171E 0%, #000000 100%)' }
  ]

  const buttons = [
    { label: 'ACADEMIA DE TRADING Y FINANZAS', link: 'https://seagreen-anteater-211196.hostingersite.com/#academia' },
    { label: 'BLOG DE ANÁLISIS DE MERCADO', link: 'https://seagreen-anteater-211196.hostingersite.com/#blug' },
    { label: 'GESTIÓN DE CAPITALES', link: 'https://seagreen-anteater-211196.hostingersite.com/#gestion-capitales' },
    { label: 'ASESORAMIENTO JURÍDICO', link: 'https://seagreen-anteater-211196.hostingersite.com/#asesoramiento' },
    { label: 'ESTUDIO DE MERCADO', link: 'https://seagreen-anteater-211196.hostingersite.com/#estudiomercado' },
    { label: 'FORMACIÓN ENSEÑANZA', link: 'https://seagreen-anteater-211196.hostingersite.com/#formacionense%C3%B1anza' },
    { label: 'ASESORAMIENTO FINANCIERO', link: 'https://seagreen-anteater-211196.hostingersite.com/#asesoramiento' },
    { label: 'BROKER', link: 'https://innovafxcapital.com/' },
    { label: 'OPERATIVA EN TIEMPO REAL', link: 'https://innovafxcapital.com/' },
  ]

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <LogoSVG style={{width: '90%'}} onClick={() => window.location.href = 'https://seagreen-anteater-211196.hostingersite.com/'} />
      </div>

      <nav className={styles.menu}>
        {buttons.map((button, index) => (
          <a 
            key={index} 
            href={button.link} 
            className={styles.menuItem} 
            style={buttonStyles[index % buttonStyles.length]}
          >
            {button.label}
          </a>
        ))}
      </nav>
    </div>
  )
}
